import { Button } from 'antd'
import _ from 'lodash'
import React from 'react'
import classes from './styles.module.scss'
import messages from './messages'
import { intl } from 'utils'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
// import { Button } from 'antd'

const IMAGES = {
  'Card Pay': intl().formatMessage(messages.bankCard),
  payby: require('./images/PayBy Pay.svg'),
  'totok-pay': require('./images/ToTok Pay.png'),
  'botim-pay': require('./images/BOTIM Pay.svg'),
  35: require('./images/Apple Pay.png'),
  36: require('./images/Google Pay.svg'),
  37: require('./images/Samsung Pay.png'),
  Balance: require('./images/Balance.png'),
  visa: require('./images/mini/visa.png'),
  mastercard: require('./images/mini/mastercard.png'),
}

const COLORS = {
  'Card Pay': {
    primary: '#80868B',
    secondary: '#fff',
  },
  payby: {
    primary: '#11BB8D',
    secondary: '#F2FDF9',
  },
  'totok-pay': require('./images/ToTok Pay.png'),
  'botim-pay': {
    primary: '#649AFB',
    secondary: '#F1FAFF',
  },
  35: {
    primary: '#000000',
    secondary: '#fff',
  },
  36: {
    primary: '#000000',
    secondary: '#fff',
  },
  37: {
    primary: '#000000',
    secondary: '#fff',
  },
}

export default class PaymentMethodButton extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { width, height, tabType, hostApp, payMethod, cardBrand, payChannel, onClick, loading } = this.props
    var img = null
    let colors = null
    const text = null
    switch (tabType) {
      case 'PAY_METHODS':
        return (
          <Button size='large' block loading={loading} type='default' onClick={onClick} className={classes.cardPayButton}>
            {intl().formatMessage(messages.bankCard)}
          </Button>
        )
      case 'MESSAGE_PAY':
        return (
          <Button size='large' block loading={loading} type='default' onClick={onClick} className={classes.cardPayButton}>
            {intl().formatMessage(messages.messagePay)}
          </Button>
        )

      case 'APP':
        img = IMAGES[hostApp]
        colors = COLORS[hostApp]
        break
      case 'DEVICE_PAY':
        img = IMAGES[_.get(payMethod, 'payMethodExtension.payChannel') || payChannel]
        break
      case 'BALANCE':
        img = IMAGES.BALANCE
        break
      case 'BANK_CARD':
        img = IMAGES[cardBrand]
        break
      case 'SRC':
        img = this.props.iconUrl
        break
      default:
        break
    }
    return (
      <Button size='large' block loading={loading} onClick={onClick} className={classes.componentsPaymentMethodIcon} style={{ borderColor: colors?.primary, backgroundColor: colors?.secondary }}>
        {img ? <img width={width} height={height} src={img} /> : text}
      </Button>
    )
  }
}
